// extracted by mini-css-extract-plugin
export default {"overskrift":"styles_overskrift__WZVya"};